module.exports = __webpack_public_path__ + "8299f9e7ebee74e41f157dc2293774d0.svg";